import { render, staticRenderFns } from "./KParserAlternatives.vue?vue&type=template&id=73c64f06&scoped=true&"
import script from "./KParserAlternatives.vue?vue&type=script&lang=js&"
export * from "./KParserAlternatives.vue?vue&type=script&lang=js&"
import style0 from "./KParserAlternatives.vue?vue&type=style&index=0&id=73c64f06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c64f06",
  null
  
)

export default component.exports